import { IFeedbackTag } from "@common/redux/types/feedbacks";

export const allFeedbackTags = new Map<string, IFeedbackTag>([
  ['clean-rooms', {
    name: 'чистые номера',
    originName: 'clean-rooms',
    minRating: 4, maxRating: 5
  }],
  ['good-service', {
    name: 'хорошее обслуживание',
    originName: 'good-service',
    minRating: 4, maxRating: 5
  }],
  ['dirty-rooms', {
    name: 'грязные номера',
    originName: 'dirty-rooms',
    minRating: 1, maxRating: 3
  }],
  ['bad-service', {
    name: 'плохое обслуживание',
    originName: 'bad-service',
    minRating: 1, maxRating: 3
  }],
  ['beautiful-interior', {
    name: 'красивый интерьер',
    originName: 'beautiful-interior',
    minRating: 1, maxRating: 5
  }],
  ['delicious', {
    name: 'вкусно',
    originName: 'delicious',
    minRating: 4, maxRating: 5
  }],
  ['tasteless', {
    name: 'невкусно',
    originName: 'tasteless',
    minRating: 1, maxRating: 3
  }],
  ['expensive', {
    name: 'дорого',
    originName: 'expensive',
    minRating: 1, maxRating: 5
  }],
  ['low-cost', {
    name: 'бюджетно',
    originName: 'low-cost',
    minRating: 1, maxRating: 5
  }],
  ['interesting', {
    name: 'Интересно',
    originName: 'interesting',
    minRating: 4, maxRating: 5
  }],
  ['useful', {
    name: 'Полезно',
    originName: 'useful',
    minRating: 4, maxRating: 5
  }],
  ['exciting', {
    name: 'Увлекательно',
    originName: 'exciting',
    minRating: 1, maxRating: 5
  }],
  ['boring', {
    name: 'Скучно',
    originName: 'boring',
    minRating: 1, maxRating: 3
  }],
  ['not-advise', {
    name: 'Не советую',
    originName: 'not-advise',
    minRating: 1, maxRating: 3
  }],
]);

export const defaultFeedbackTags: IFeedbackTag[] = [
  {
    name: 'интересно',
    originName: 'interesting',
    minRating: 4, maxRating: 5,
  },
  {
    name: 'полезно',
    originName: 'useful',
    minRating: 4, maxRating: 5,
  },
  {
    name: 'увлекательно',
    originName: 'exciting',
    minRating: 4, maxRating: 5,
  },
  {
    name: 'скучно',
    originName: 'boring',
    minRating: 1, maxRating: 3,
  },
  {
    name: 'не советую',
    originName: 'not-advise',
    minRating: 1, maxRating: 3,
  },
];

export const feedbackHotelTags: IFeedbackTag[] = [
  {
    name: 'хорошее обслуживание',
    originName: 'good-service',
    minRating: 4, maxRating: 5,
  },
  {
    name: 'чистые номера',
    originName: 'clean-rooms',
    minRating: 4, maxRating: 5,
  },
  {
    name: 'красивый интерьер',
    originName: 'beautiful-interior',
    minRating: 1, maxRating: 5,
  },
  {
    name: 'плохое обслуживание',
    originName: 'bad-service',
    minRating: 1, maxRating: 3,
  },
  {
    name: 'грязные номера',
    originName: 'dirty-rooms',
    minRating: 1, maxRating: 3,
  },
];

export const feedbackRestaurantTags: IFeedbackTag[] = [
  {
    name: 'хорошее обслуживание',
    originName: 'good-service',
    minRating: 4, maxRating: 5,
  },
  {
    name: 'красивый интерьер',
    originName: 'beautiful-interior',
    minRating: 1, maxRating: 5,
  },
  {
    name: 'вкусно',
    originName: 'delicious',
    minRating: 4, maxRating: 5,
  },
  {
    name: 'бюджетно',
    originName: 'low-cost',
    minRating: 1, maxRating: 5,
    disabled: ['expensive']
  },
  {
    name: 'плохое обслуживание',
    originName: 'bad-service',
    minRating: 1, maxRating: 3,
  },
  {
    name: 'дорого',
    originName: 'expensive',
    minRating: 1, maxRating: 5,
    disabled: ['low-cost']
  },
  {
    name: 'невкусно',
    originName: 'tasteless',
    minRating: 1, maxRating: 3,
  },
];
